import { Config} from '@forgerock/javascript-sdk';


export const setForgerockConfig = (tree: string) => {
  Config.set(
    {
      clientId: process.env.NEXT_PUBLIC_FORGEROCK_CLIENT_ID,
      redirectUri: process.env.NEXT_PUBLIC_FORGEROCK_REDIRECT_URL,
      scope: "openid profile email UAEPASS",
      serverConfig: {
        baseUrl: process.env.NEXT_PUBLIC_FORGEROCK_WEB_URL,
        timeout: 10000,
      },
      realmPath: "alpha",
      tree: tree,
    }
  );
}


// clientId: "aldarPoc", DEV, QA, STG, PREPROD
// clientId: "FRPROD", PROD

